/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/ClientSide/javascript.js to edit this template
 */


import { useState, useEffect }
    from "react";
import { useParams, useLocation }
    from 'react-router-dom';

import { Container, Row, Col, Tab, Nav }
    from 'react-bootstrap';
import { library }
    from '@fortawesome/fontawesome-svg-core';
import { fas }
    from '@fortawesome/free-solid-svg-icons';
import { fab }
    from '@fortawesome/free-brands-svg-icons';
import { far }
    from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon }
    from '@fortawesome/react-fontawesome';

library.add(fas, fab, far);
function DeliveryInfo() {

    return (
        <div>
            <Row><h2>Delivery Information</h2></Row>
            <br />
            <Row>
                <p>
                    We make shopping simple, fast, and flexible — just the way you like it! Here's everything you need to know about our delivery options.<br /><br />
                    <b>Delivery Charges?</b><br />
                    •	FREE Delivery on all orders above ₹1000! <br />
                    •	Delivery charges vary based on your location and the type of delivery (Standard or Express). <br />
                    •	You’ll see exact charges at checkout based on your pin code.
                    <br />
                    <br />

                    <b>Delivery Options</b><br />

                    We offer three convenient ways to get your groceries:<br />
                    1.	Standard Delivery – Reliable, everyday delivery at your doorstep.<br />
                    2.	Express Delivery – Get your order in a 1-hour slot. Fast. Fresh. Right on time.<br />
                    3.	Takeaway Option – Order online, pick it up from your nearest Grace store at your convenience.
                    <br />


                    <br />
                    <b>Standard Delivery</b><br />

                    •	Delivery time depends on:<br />
                    o	Product availability<br />
                    o	Your location<br />
                    o	Courier partner's local delivery times<br />
                    •	Enter your pin code once to get accurate delivery estimates – no need to re-enter every time!
                    <br />

                    <br />
                    <b>How Express Delivery Works</b><br />
                    •	Order placed between 11:00 AM – 12:00 PM? Your delivery slot will be 1:00 PM – 2:00 PM.<br />
                    •	Order placed between 12:00 PM – 1:00 PM? Your delivery slot will be 2:00 PM – 3:00 PM.
                    <br />

                    <br />
                    <b>Takeaway (Store Pick-Up)</b><br />

                    •	No delivery slots available? No worries! <br />
                    •	Place your order online and collect it at your nearest Grace outlet via our website or mobile app. <br />
                    •	Fast. Hassle-free. On your schedule.
                    <br />

                    <br />
                    <b>Why is Cash on Delivery (COD) Not Available for Me?</b><br />
                    •	Currently, we deliver within Chennai only.<br />
                    •	For bulk orders or non-perishable items, we may arrange out-of-Chennai delivery with extra shipping charges.<br />
                    •	Interested? Contact us with your requirements, and we’ll be happy to assist.<br />
                    <br />
                </p>
            </Row>
        </div>

    );
}

export default DeliveryInfo;